var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeroBlob1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 600,
    height: 441,
    viewBox: "0 0 600 441",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Watercolor blob",
    filter: "url(#filter0_f_0_57)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M268.966 58.8C341.379 29.4 444.828 49 486.207 117.6C537.931 196 496.552 254.8 537.931 313.6C568.966 372.4 486.207 421.4 393.103 411.6C310.345 401.8 258.621 372.4 175.862 382.2C93.1034 392 41.3793 323.4 62.069 254.8C82.7586 186.2 186.207 98 268.966 58.8Z",
    fill: "url(#paint0_linear_0_57)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_57",
    x: -22,
    y: -22,
    width: 644,
    height: 485,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "effect1_foregroundBlur_0_57"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_57",
    x1: 57.5068,
    y1: 45.57,
    x2: 309.739,
    y2: 380.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C9DAFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4DCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBlob1);
export default __webpack_public_path__ + "static/media/hero-blob-1.0fc626565097359db3c7128db486f21d.svg";
export { ForwardRef as ReactComponent };